import { endpoints, axiosInstance } from 'src/utils/axios';

interface VerifyRegisterResponse {
  exists: boolean;
}

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  adminUser?: {
    id: string;
    email: string;
    role: string;
    active: boolean;
    displayName?: string;
    lastLoginAt?: string;
  };
}

interface LoginData {
  phone: string;
  code: string;
}

interface RegisterData {
  name: string;
  cpf: string;
  phone: string;
  termId: string;
  sellerId?: string;
}

export const authRepository = {
  async verifyRegister(phone: string): Promise<VerifyRegisterResponse> {
    const response = await axiosInstance.post(endpoints.auth.verifyRegister, { phone });

    if (!response.data) {
      throw new Error('Verify register failed');
    }

    return response.data;
  },

  async sendLoginCode(phone: string): Promise<void> {
    await axiosInstance.post(endpoints.auth.sendLoginCode, { phone });
  },

  async login(data: LoginData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.auth.loginSms, data);

    if (!response.data) {
      throw new Error('Login failed');
    }

    return response.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.appUsers.register, data);

    if (!response.data) {
      throw new Error('Registration failed');
    }

    return response.data;
  },

  async refreshAccessToken(refreshToken: string): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.auth.refresh, { refreshToken });

    if (!response.data?.accessToken) {
      throw new Error('Failed to refresh access token');
    }

    return {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken || refreshToken, // Se não vier novo, usa o atual
    };
  },

  async logout(): Promise<void> {
    await axiosInstance.post(endpoints.auth.logout);
  },
};
